// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { API_PLANTILLAS_EMAIL } from "../views/MainLayout/components/shared/services/plantillasEmail";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialPlantillas = []

export const plantillasEmailFullfilledReducer = (state = initialPlantillas, action) => {
  switch(action.type){
    case "plantillas_email/fullfilled": {            
      return action.payload;
    }
    default:
      return state
  }
}


export const fetchPlantillasEmail = () => async (dispatch) => {
  dispatch({ type: 'loading/set', payload: true })

  try {
    const response = await API_PLANTILLAS_EMAIL.getPlantillasEmail()
    const data = await response.data;

    dispatch({ type: "plantillas_email/fullfilled", payload: data });

    const readOnly = JSON.parse(localStorage.getItem('read_only'));
    readOnly.plantillas_email = data;
    localStorage.setItem('read_only', JSON.stringify(readOnly));

  } catch (e) {
    toast.error(setErrorMessage(e))
  } finally {
    dispatch({ type: 'loading/set', payload: false })
  }
};